module.exports = __webpack_public_path__ + "static/media/screenshot6.66de0e66.png";